import type { DevEnv } from "@p0security/shared/types/environment";

// GCP Workload Identity Pool/provider IDs must be 4-32 characters, lowercase
// letters, numbers, and hyphens, and cannot start with "gcp-".
const sanitizeForWifId = (name: string) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "-")
    .slice(0, 32);

const envSuffixFor = (context: DevEnv) =>
  "developer" in context
    ? `-dev-${context.developer.toLowerCase()}`
    : context.environment.startsWith("dev") ||
        context.environment.startsWith("test")
      ? "-dev"
      : context.environment.startsWith("stage")
        ? "-stage"
        : "";

/** Deterministic Workload Identity Pool ID for a gcp-wif install
 *
 * Customers create the pool with this ID when running the generated
 * Terraform/gcloud CLI setup instructions.
 */
export const p0WifPoolId = (context: DevEnv, installName: string) =>
  sanitizeForWifId(`p0-wif-pool-${installName}${envSuffixFor(context)}`);

/** Deterministic Workload Identity Pool provider ID for a gcp-wif install */
export const p0WifProviderId = (context: DevEnv, installName: string) =>
  sanitizeForWifId(`p0-wif-provider-${installName}${envSuffixFor(context)}`);
